import React from "react";
import "./narbar.scss";

const Nav: React.FC = () => {

    return (
        <>
            


        </>
    );
};
export default Nav;
